import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "onCloseAll", "value", "open", "setOpen", "onClose", "showLength", "tagRender", "valueName", "maxShowLength", "allOptionSelected", "allOptionLabel", "maxLength", "noBorder", "isOptionDisabled", "disableAll"],
    _excluded2 = ["onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { getObjectValue, isEventElementMatch } from '../tools/util';
import { getLocale } from '../locale';
import MultipleBaseInput, { canElementTriggerEvent } from '../MultipleBaseInput';
import ConfigConsumer from '../ConfigConsumer';
import Icon from '../Icon';
export default function MultiSelector(_ref) {
  var className = _ref.className,
      _onCloseAll = _ref.onCloseAll,
      selected = _ref.value,
      open = _ref.open,
      setOpen = _ref.setOpen,
      _onClose = _ref.onClose,
      showLength = _ref.showLength,
      tagRender = _ref.tagRender,
      valueName = _ref.valueName,
      maxShowLength = _ref.maxShowLength,
      allOptionSelected = _ref.allOptionSelected,
      allOptionLabel = _ref.allOptionLabel,
      maxLength = _ref.maxLength,
      noBorder = _ref.noBorder,
      isOptionDisabled = _ref.isOptionDisabled,
      disableAll = _ref.disableAll,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var locale = _ref2.locale;
    var tags = allOptionSelected ? [{
      closable: !disableAll,
      onClose: function onClose() {
        _onCloseAll();

        setOpen(true);
      },
      children: allOptionLabel !== null && allOptionLabel !== void 0 ? allOptionLabel : getLocale(locale).common.all
    }] : selected.map(function (item) {
      var value = getObjectValue(item, valueName);

      var _tagRender = tagRender(item),
          _tagRender$onClick = _tagRender.onClick,
          onClick = _tagRender$onClick === void 0 ? function () {} : _tagRender$onClick,
          other = _objectWithoutProperties(_tagRender, _excluded2);

      return _objectSpread(_objectSpread({
        closable: !isOptionDisabled(item)
      }, other), {}, {
        onClose: function onClose() {
          onClick();

          _onClose(value);

          setOpen(true);
        }
      });
    });
    return /*#__PURE__*/React.createElement(MultipleBaseInput, _extends({
      closeWhenTagClose: true,
      empty: !tags.length,
      onClick: function onClick(e) {
        // 如果可以触发事件，切换面板展开
        if (isEventElementMatch(e, canElementTriggerEvent)) {
          setOpen(!open);
        }
      },
      onToggleExpand: function onToggleExpand(expand) {
        if (expand) {
          setOpen(false);
        }
      },
      showLength: (showLength || maxLength) && !allOptionSelected && selected.length > 0,
      focused: open,
      className: classNames('jmtd-multi-selector', 'jmtd-selector', className, {
        'jmtd-selector-no-border': noBorder
      }),
      tags: tags,
      endIcon: /*#__PURE__*/React.createElement(Icon, {
        className: "jmtd-selector-arrow jmti-angle-down"
      }),
      onCloseAll: function onCloseAll() {
        _onCloseAll();

        setOpen(true);
      },
      maxLength: maxLength,
      maxShowLength: maxShowLength
    }, others));
  });
}
MultiSelector.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  value: PropTypes.any.isRequired,
  setOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxLength: PropTypes.number,
  showLength: PropTypes.bool,
  tagRender: PropTypes.func,
  valueName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  placeholder: PropTypes.string,
  maxShowLength: PropTypes.number,
  onCloseAll: PropTypes.func,
  allOptionSelected: PropTypes.bool,
  allOptionLabel: PropTypes.string,
  noBorder: PropTypes.bool,
  isOptionDisabled: PropTypes.func,
  disableAll: PropTypes.bool
};
MultiSelector.defaultProps = {
  className: '',
  width: null,
  maxLength: null,
  showLength: false,
  tagRender: function tagRender(item) {
    return item.label;
  },
  valueName: 'value',
  placeholder: '',
  maxShowLength: 30,
  onCloseAll: function onCloseAll() {},
  allOptionSelected: false,
  allOptionLabel: null,
  noBorder: false,
  isOptionDisabled: function isOptionDisabled(item) {
    return item.disabled;
  },
  disableAll: false
};